<template>
  <div class="f1-countdown">
    <div class="f1-countdown__number-col">
      <span class="f1-countdown__number">
        {{nextRaceDays}}
      </span>
      <span class="f1-countdown__number-label">
        {{nextRaceDays === '01' ? $t('seasonBox.day') : $t('seasonBox.days')}}
      </span>
    </div>
    <div class="f1-countdown__number-col">
      <span class="f1-countdown__number">
        {{nextRaceHours}}
      </span>
      <span class="f1-countdown__number-label">
        {{nextRaceHours === '01' ? $t('seasonBox.hour') : $t('seasonBox.hours')}}
      </span>
    </div>
    <div class="f1-countdown__number-col">
      <span class="f1-countdown__number">
        {{nextRaceMinutes}}
      </span>
      <span class="f1-countdown__number-label">
        {{nextRaceMinutes === '01' ? $t('seasonBox.minute') : $t('seasonBox.minutes')}}
      </span>
    </div>
    <div class="f1-countdown__number-col">
      <span class="f1-countdown__number">
        {{nextRaceSeconds}}
      </span>
      <span class="f1-countdown__number-label">
        {{nextRaceSeconds === '01' ? $t('seasonBox.second') : $t('seasonBox.seconds')}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'f1-countdown',
  props: ['nextRaceDate'],
  data () {
    return {
      enabled: false,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  methods: {
    watchTime () {
      this.enabled = true;
      setInterval(this.nextRaceDiff, 1000);
    },
    nextRaceDiff () {
      const now = new Date();
      const diff = this.nextRaceDate - now;
      const days = diff / 86400000;
      const restDay = diff % 86400000;
      const hours = restDay / 3600000;
      const hoursRest = restDay % 3600000;
      const minutes = hoursRest / 60000;
      const minutesRest = hoursRest % 60000;
      const seconds = minutesRest / 1000;
      this.days = Math.floor(days);
      this.hours = Math.floor(hours);
      this.minutes = Math.floor(minutes);
      this.seconds = Math.floor(seconds);

      if (!this.enabled) {
        this.watchTime();
      }
    },
  },
  computed: {
    nextRaceDays () {
      return this.days < 10 ? `0${this.days}` : this.days;
    },
    nextRaceHours () {
      return this.hours < 10 ? `0${this.hours}` : this.hours;
    },
    nextRaceMinutes () {
      return this.minutes < 10 ? `0${this.minutes}` : this.minutes;
    },
    nextRaceSeconds () {
      return this.seconds < 10 ? `0${this.seconds}` : this.seconds;
    },
  },
  mounted () {
    this.nextRaceDiff();
  },
};
</script>
